module.exports = __webpack_public_path__ + "static/educative-code-running-a48cc2ec78d4b266824a5c062eecb2c6.mp4";